/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_No_Changes_To_Save_ToastInputs */



/**
* | output |
* | --- |
* | "No changes to save" |
*
* @param {Knp_Lookup_No_Changes_To_Save_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_no_changes_to_save_toast = /** @type {((inputs?: Knp_Lookup_No_Changes_To_Save_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_No_Changes_To_Save_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun changement a enregistrer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Änderungen zum Speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna modifica da salvare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменений для сохранения нет.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay cambios para guardar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无需保存任何更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存する変更はありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई बदलाव सहेजने के लिए नहीं हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma alteração para salvar")
	return /** @type {LocalizedString} */ ("No changes to save")
});